/**
 * Тексты сайта на сербском (латиница) и английском. Формулировка: «программа записи с ИИ-ответами»,
 * без «автоматизации Instagram» и без рассылок (правила Paddle). Цены по концепту от 27.10.2026.
 */
export type SiteLang = "sr" | "en";

export const siteText = {
  sr: {
    nav: { pricing: "Cene", terms: "Uslovi", refund: "Povraćaj", privacy: "Privatnost", login: "Prijava" },
    hero: {
      title: "Program za zakazivanje sa AI odgovorima",
      text: "Kalendar za salone i berbernice koji rade po zakazivanju. AI asistent odgovara na pitanja klijenata u Instagram porukama i upisuje termine u vaš kalendar, i to samo na osnovu podataka koje je salon uneo.",
      cta: "Pogledajte cene",
      login: "Prijava za salone",
    },
    features: {
      title: "Šta dobijate",
      items: [
        { title: "Kalendar", text: "Usluge sa cenom i trajanjem, majstori, rasporedi, slobodni dani i ručno zakazivanje u dva dodira." },
        {
          title: "AI odgovori",
          text: "Cene, usluge, adresa, radno vreme i pravila: samo iz podataka salona. Ako odgovora nema, asistent kaže: „proveriću sa majstorom“.",
        },
        { title: "Majstor je uvek glavni", text: "Obaveštenja svim majstorima, dugme „preuzmi razgovor“, asistent ćuti dok majstor odgovara." },
        { title: "Stranica za zakazivanje", text: "Link za Instagram profil i QR kod: klijent zakazuje bez dopisivanja." },
        { title: "Mesečni pregled", text: "Jedan red mesečno: koliko klijenata je asistent zakazao i na koji iznos." },
        { title: "Bez avansa", text: "Ne naplaćujemo ništa vašim klijentima i ne šaljemo masovne poruke." },
      ],
    },
    pricing: {
      title: "Cene",
      plan: "Pretplata",
      price: "€25",
      per: "mesečno",
      points: [
        "Bez provizija i bez ograničenja broja razgovora (uz dnevnu zaštitu od spama)",
        "Prvi mesec probni: kartica se unosi odmah, naplata posle 30 dana",
        "Otkazivanje u bilo kom trenutku, bez ugovora na godinu",
      ],
      setupTitle: "Povezivanje",
      self: { title: "Povezujete se sami", price: "Besplatno", text: "Čarobnjak za podešavanje, oko 15 minuta." },
      done: {
        title: "Povežemo za vas",
        price: "€30 jednokratno",
        text: "Mi unosimo usluge, cene i pravila i proveravamo asistenta. Plaća se zajedno sa pretplatom.",
      },
      vat: "Porez, ako se obračunava, Paddle računa pri plaćanju prema zemlji kupca i prikazuje ukupan iznos pre plaćanja.",
      mor: "Plaćanja obrađuje Paddle.com, koji je Merchant of Record za sve naše porudžbine.",
      start: "Započni",
    },
    footer: { rights: "Sva prava zadržana." },
    draft: "Nacrt: tekst još nije pregledao pravnik.",
    updated: "Poslednja izmena",
  },
  en: {
    nav: { pricing: "Pricing", terms: "Terms", refund: "Refunds", privacy: "Privacy", login: "Log in" },
    hero: {
      title: "Booking software with AI replies",
      text: "A calendar for salons and barbershops that work by appointment. The AI assistant answers clients' questions in Instagram messages and books appointments into your calendar, using only the information the salon has entered.",
      cta: "See pricing",
      login: "Salon login",
    },
    features: {
      title: "What you get",
      items: [
        { title: "Calendar", text: "Services with price and duration, staff, schedules, days off and manual booking in two taps." },
        {
          title: "AI replies",
          text: "Prices, services, address, opening hours and rules: only from the salon's data. If there is no answer, the assistant says it will check with the staff.",
        },
        { title: "Staff stay in charge", text: "Notifications to all staff, a “take over” button, the assistant stays silent while a person is replying." },
        { title: "Booking page", text: "A link for the Instagram profile and a QR code: clients book without chatting." },
        { title: "Monthly summary", text: "One line a month: how many clients the assistant booked and for how much." },
        { title: "No prepayments", text: "We never charge your clients and never send bulk messages." },
      ],
    },
    pricing: {
      title: "Pricing",
      plan: "Subscription",
      price: "€25",
      per: "per month",
      points: [
        "No commissions and no limits on conversations (with a daily anti-spam safeguard)",
        "First month is a trial: card required, first charge after 30 days",
        "Cancel any time, no annual contract",
      ],
      setupTitle: "Setup",
      self: { title: "Self setup", price: "Free", text: "A setup wizard, about 15 minutes." },
      done: {
        title: "Done for you",
        price: "€30 one-time",
        text: "We enter services, prices and rules and test the assistant. Paid together with the subscription.",
      },
      vat: "Any applicable tax is calculated by Paddle at checkout based on the buyer's country and shown before you pay.",
      mor: "Payments are processed by Paddle.com, the Merchant of Record for all our orders.",
      start: "Get started",
    },
    footer: { rights: "All rights reserved." },
    draft: "Draft: this text has not yet been reviewed by a lawyer.",
    updated: "Last updated",
  },
} as const;
